import { CnDialog } from './dialog';
import { CnPopup } from './popup';
import { alert, confirm, error, help, hide, notice, show, success, warning, } from './funcs';
import './styles/index.scss';
// @ts-ignore
CnDialog.show = show;
CnDialog.hide = hide;
CnDialog.alert = alert;
CnDialog.success = success;
CnDialog.error = error;
CnDialog.notice = notice;
CnDialog.warning = warning;
CnDialog.help = help;
CnDialog.confirm = confirm;
CnDialog.Popup = CnPopup;
CnPopup.displayName = 'CnPopup';
const CnDialogBase = CnDialog; // 非要导出一个单纯的React.FC<CnDialogProps>才能生成文档，如果是继承类型CnDialogComponent文档出不来
CnDialog.displayName = 'CnDialog'; // CnDialogComponent
export { CnPopup, CnDialog, CnDialogBase };
